import React from 'react';

const Tab = ({ text, activeTab, setActiveTab }) => {
  return (
    <span className={`tab heading5 ${activeTab ? 'active' : ''}`} onClick={setActiveTab}>
      {text}
    </span>
  );
};
export default Tab;
